<template>
  <div class="fgas-BottomBlock">
    <!--
     <template v-if="!isObjective && !hasContributeChildren">
      <ul v-if="!isEmpty(listItems)" class="fgas-List">
        <li v-for="(item, index) in listItems" :key="index" class="fgas-ListItem">
          <span class="fgas-ListItem_Name oboard-truncated-text">{{ item.name }}</span>
          <span class="fgas-ListItem_Value">{{ item.value }}</span>
        </li>
      </ul>
    </template>
    -->

    <ul v-if="!isTask && !isEmpty(listItems)" class="fgas-List">
      <li v-for="(item, index) in listItems" :key="index" class="fgas-ListItem">
        <span class="fgas-ListItem_Name oboard-truncated-text">{{ item.name }}</span>
        <span class="fgas-ListItem_Value oboard-truncated-text">{{ item.value }}</span>
      </li>
    </ul>

    <template v-if="!disabled">
      <div v-if="isTask">
        <AppButton
          :class="{ [`fgas-BtnUpdateProgress-${uniqId}`]: true }"
          :size="BUTTON_SIZES.LG_NEXT"
          class="fgas-BtnUpdateProgress"
          @click="toggleShowSelect"
        >
          <span class="oboard-truncated-text">
            {{ checkinButtonText }}
          </span>
        </AppButton>

        <GradeSelect
          v-if="editInitialised"
          v-model:show="showSelect"
          :element-target-periods="elementTargetPeriods"
          :objective="formModel"
          :offset="[0, -40]"
          :to-selector="`.fgas-BtnUpdateProgress-${uniqId}`"
          position="bottom-end"
          @save="emit('save-grade', $event)"
          @error-on-save="handleInlineUpdateError"
        />
      </div>

      <CheckinModalTrigger
        v-else
        :entry-point="CHECKIN_MODAL_ENTRY_POINTS.CREATE"
        :okr-element="formModel"
        @open-checkin-modal="emit('open-checkin-modal', $event)"
      >
        <template #trigger-content>
          {{ checkinButtonText }}
        </template>
      </CheckinModalTrigger>
    </template>
  </div>
</template>

<script setup>
import { isEmpty } from 'lodash'
import { computed, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

import { CHECKIN_MODAL_ENTRY_POINTS, useLastCheckin } from '@/utils/check-ins/check-ins'
import { BUTTON_SIZES } from '@/utils/components-configurations/app-button'
import { useInlineUpdate } from '@/utils/element-progress'
import { isJiraIssueOrWorkItem } from '@/utils/objective-types'
import { DEFAULT_MILESTONES_SETTINGS } from '@/utils/okr-element-values'
import { uid } from '@/utils/uid'
import { OKR_ELEMENT_KEYS } from '@/utils/view-row-actions'

import CheckinModalTrigger from '@/components/objectives/element-check-in/CheckinModalTrigger'
import GradeSelect from '@/components/objectives/GradeSelect'
import AppButton from '@/components/ui/AppButton/AppButton'

defineOptions({
  name: 'FormGradeAndStatusBottomBlock'
})

const { t } = useI18n()

const props = defineProps({
  formModel: {
    type: Object,
    required: true
  },

  disabled: {
    type: Boolean
  },

  isOkrElementClosed: {
    type: Boolean
  },

  elementTargetPeriods: {
    type: Array,
    default: () => DEFAULT_MILESTONES_SETTINGS[OKR_ELEMENT_KEYS.ELEMENT_TARGET_PERIODS]
  }
})

// const { ORIGINAL_VALUE, CURRENT_VALUE, TARGET_VALUE, THRESHOLD_TARGET_VALUE, BINARY_VALUE } =
//   METRIC_VALUES_KEYS

const uniqId = uid()

const emit = defineEmits({
  'open-checkin-modal': null,
  'save-grade': null
})

const {
  onTriggerClick: toggleShowSelect,
  isShowInlineUpdateForm: showSelect,
  editInitialised,
  handleInlineUpdateError
} = useInlineUpdate({
  props: reactive({
    updatable: !props.disabled
  })
})

const isTask = computed(() => isJiraIssueOrWorkItem(props.formModel))

// const isTaskOrMetric = computed(() => isKR(props.formModel) || isTask.value)

// const isObjective = computed(() => !isTaskOrMetric.value)

//const getSimplifiedValue = (v = 0) => getSimplifiedNumber(v)[PLURALIZATION_KEYS.SIMPLIFIED]

const lastCheckin = computed(() => {
  return props.formModel[OKR_ELEMENT_KEYS.LAST_CHECKIN]
})

const { lastCheckinRelativeDate } = useLastCheckin({
  lastCheckin
})

const listItems = computed(() => {
  return [
    {
      name: t('checkin'),
      value: lastCheckinRelativeDate.value
    }
  ]

  /*
  if (isObjective.value) {
    return []
  }

  const formModel = props.formModel

  const LIST_ITEMS = {
    CURRENT_VALUE_FOR_BINARY: {
      name: t('create.keyResult.label.currentValue'),
      value: t(BINARY_OPTIONS[formModel[BINARY_VALUE]].label)
    },
    ORIGINAL_VALUE: {
      name: t('create.keyResult.label.originalValue'),
      value: getSimplifiedValue(formModel[ORIGINAL_VALUE])
    },
    CURRENT_VALUE: {
      name: t('create.keyResult.label.currentValue'),
      value: getSimplifiedValue(formModel[CURRENT_VALUE])
    },
    THRESHOLD: {
      name: t('objectives.threshold'),
      value: `${getThresholdConditionSymbol({
        conditionId: props.formModel.thresholdConditionTypeId
      })} ${getSimplifiedValue(formModel[THRESHOLD_TARGET_VALUE])}`
    },
    TARGET_VALUE: {
      name: t('create.keyResult.label.targetValue'),
      value: getSimplifiedValue(formModel[TARGET_VALUE])
    },
    UNIT: {
      name: t('common.unit'),
      value: formModel.unit
    }
  }

  if (isBinaryProgress({ element: formModel })) {
    return [LIST_ITEMS.CURRENT_VALUE_FOR_BINARY]
  }

  const isThresholdItem = isThresholdProgress({ element: formModel })

  return [
    isThresholdItem ? LIST_ITEMS.THRESHOLD : LIST_ITEMS.ORIGINAL_VALUE,
    isThresholdItem ? null : LIST_ITEMS.CURRENT_VALUE,
    isThresholdItem ? null : LIST_ITEMS.TARGET_VALUE,
    isStringEmpty(formModel.unit) ? null : LIST_ITEMS.UNIT
  ].filter(Boolean)

   */
})

// const hasContributeChildren = computed(() => {
//   return Boolean(props.formModel?.existContributeChildren)
// })

const checkinButtonText = computed(() => {
  if (isTask.value) {
    return t('common.update_progress')
  }

  if (props.isOkrElementClosed) {
    return t('dashboard.reopen')
  }

  return t('checkin')
})
</script>

<style lang="scss" scoped>
.fgas-List {
  list-style: none;
  display: flex;
  flex-direction: column;
  max-width: 100%;
  gap: 16px;
  // margin: 0 0 24px 0;
  margin: 0;
  overflow: hidden;
}

.fgas-ListItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fgas-ListItem_Value {
  color: $dark-1;
  font-weight: fw('semi-bold');
  white-space: nowrap;
}

.fgas-ListItem_Name {
  color: $dark-3;
  flex-grow: 1;
  flex-shrink: 0;
}

.fgas-BottomBlock {
  // padding: 0 18px;
  overflow: hidden;
  background-color: $grey-3-next;
  display: grid;
  gap: 20px;

  &:not(&:empty) {
    padding: 20px 18px 18px;
  }
}

.fgas-BtnUpdateProgress {
  width: 100%;
  overflow: hidden;
  // margin: 0 0 24px 0;
}
</style>
